import React, { useContext } from "react";
import { Button, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import AppContext from "../../context/Context";
import SikkaInput from "../common/SikkaInput";

const PartnerCustomerListApiAccessModal = ({ setApiAccessCommentModal, handleUserTypeUpdateClick }) => {
  const { register, handleSubmit, errors } = useForm();

  const { loginUserDetails } = useContext(AppContext);

  return (
    <div>
      <Form onSubmit={handleSubmit(handleUserTypeUpdateClick)}>
        <SikkaInput
          label="Updated By"
          name="updatedBy"
          id="updatedBy"
          disabled
          value={loginUserDetails.user_name}
          innerRef={register({
            required: "New Email is required",
          })}
          errors={errors}
        />
        <SikkaInput
          type="textarea"
          label="Comment"
          name="comment"
          id="comment"
          innerRef={register({
            required: "Comment is required",
            pattern: {
              value: /^[^\s]+(\s+[^\s]+)*$/,
              message: "Invalid comment",
            },
          })}
          errors={errors}
        />
        <Row form className="modal-footer bg-light" style={{ marginBottom: "-16px" }}>
          <Button className="ml-auto" size="sm" variant="outline-primary" type="submit">
            Save
          </Button>
          <Button
            size="sm"
            variant="outline-danger"
            onClick={() => {
              setApiAccessCommentModal(false);
            }}
          >
            Cancel
          </Button>
        </Row>
      </Form>
    </div>
  );
};

export default PartnerCustomerListApiAccessModal;
